import { roomTranslationApi } from "@/core/api/room.translation.api";

export default {
  async enableTranslation(
    { dispatch, commit, state, rootState, rootGetters },
    data
  ) {
    await roomTranslationApi.enableTranslation(data);
    commit("SET_TRANSLATION_INFO", data);
    commit("ENABLE_TRANSLATION", data);
  },

  async translationText(
    { dispatch, commit, state, rootState, rootGetters }, {
        text,
        sourceLang,
        targetLang,
        eventName,
        eventPublish
    }
  ) {
    await roomTranslationApi.translationText({
      text,
      sourceLang, targetLang,
      eventName, eventPublish
    });
  },

  getTranslationUse(){
    return roomTranslationApi.getTranslationUse();
  }
};
